import type { FC } from "react"
import { NavLink } from "react-router"
import { Logo } from "@/components/Logo"
import { cn } from "@/lib/utils"

const MENU_ITEMS = [
  { to: "/dashboard", label: "ダッシュボード" },
  { to: "/restaurants", label: "店舗管理" },
  { to: "/transactions", label: "取引管理" },
  { to: "/setting/members", label: "システム設定" },
] as const

export const AdminTopNav: FC = () => {
  return (
    <header className="border-b border-border bg-bg-white">
      <div className="relative mx-auto flex h-12 max-w-[1280px] items-center px-6">
        <Logo className="relative z-10 shrink-0" />

        <nav className="absolute inset-y-0 left-1/2 hidden -translate-x-1/2 items-stretch md:flex">
          {MENU_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                cn(
                  "flex w-40 items-center justify-center text-body-md font-semibold leading-normal text-text transition-colors",
                  isActive ? "bg-gray text-bg-white" : "bg-bg-white hover:bg-background"
                )
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <nav className="ml-auto flex items-center overflow-x-auto md:hidden">
          {MENU_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                cn(
                  "shrink-0 px-3 py-2 text-label-lg font-semibold text-text",
                  isActive && "text-gray"
                )
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
  )
}
